import { render, staticRenderFns } from "./PSelection.vue?vue&type=template&id=8a333984&scoped=true&"
import script from "./PSelection.vue?vue&type=script&lang=js&"
export * from "./PSelection.vue?vue&type=script&lang=js&"
import style0 from "./PSelection.vue?vue&type=style&index=0&id=8a333984&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a333984",
  null
  
)

export default component.exports